import { type Analytics, AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

declare global {
  interface Window {
    customerio?: Analytics
  }
}

export const useCustomerIo = () => {
  const load = async () => {
    // Disable in-app messaging for localhost to prevent interference with testing
    const anonymousInApp = location.hostname !== 'localhost'

    if (!import.meta.env.PUBLIC_CUSTOMER_IO_WRITE_KEY) {
      return
    }

    const customerio = AnalyticsBrowser.load(
      {
        writeKey: import.meta.env.PUBLIC_CUSTOMER_IO_WRITE_KEY,
      },
      {
        integrations: {
          'Customer.io In-App Plugin': {
            anonymousInApp,
          },
        },
      }
    )

    customerio
      .then(([analytics]) => {
        window.customerio = analytics

        analytics.page()
      })
      .then()
  }

  return {
    load,
  }
}
